<template>

    <div class="">

        <div class="col-12 table-header" style="height: 1px; background-color:#999;"></div>

        <div class="filters" :class="{'is-open': filtersOpen}">

            <div class="filter-close" @click="closeFilters"><i class="bi bi-x-circle-fill"></i></div>

            <div class="filter-buttons">

               <span @click="closeFilters"><i class="bi bi-x-lg"></i></span>

            </div>

            <div v-for="(value, name, index) in filters" class="dropdown" :class="{ 'is_active':  filterState[name] && filterState[name].length > 0}">

                <template v-if="['duration', 'layover_time', 'departure_time', 'arrival_time'].includes(name)">

                    <div class="slider-block me-3">

                        <div class="flightsleaving-filter-header" style="margin-bottom: 10px">{{ filterLabel[name] }}<br/><span>{{ formatLabel(filterState[name][0]) }} - {{ formatLabel(filterState[name][1]) }}</span></div>

                        <slider @change="modifyFilters($event, name)" v-model="filterState[name]" :min="value[0] ?? 0" :max="value[1] ?? 0" :step="5" :format="formatLabel" showTooltip="drag"></slider>

                    </div>

                </template>

                <template v-else>



                    <button class="show-desktop btn btn-filter dropdown-toggle filter-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">

                        {{ filterLabel[name] }}

                    </button>

                    <div class="filter-headline-mobile show-mobile">

                        {{ filterLabel[name] }}

                    </div>




                    <ul class="dropdown-menu">

                        <template v-for="option in value">

                            <li>

                                <label class="dropdown-item" :class="{ 'empty': !filtersCount[name][option.value] }"><input type="checkbox" v-model="filterState[name]" :value="option.value" @change="modifyFilters($event, name)">{{ option.label }} ({{ filtersCount[name][option.value] ?? 0 }})</label>
                            </li>

                        </template>

                    </ul>

                </template>

            </div>

            <div class="d-none d-lg-flex" v-if="showClearFilters">
                <button @click="clearFilters" class="btn btn-secondary clear">x Clear filters</button>
            </div>
            <div class="mobile-filter">
                <button @click="clearFilters" class="clear">CLEAR</button>
                <button @click="toggleFilter" class="done">DONE</button>
            </div>
        </div>
        <div class="under-filter">
            <div>
                <span class="under-filter-text">{{ sortedRoutes.length }} flights to {{ airportToName }} on <strong>{{ currentDate }}</strong>. {{ directFlightsCount }} Direct flights and {{ routes.length - directFlightsCount }} flights with 1 stop.</span>
            </div>
            <div class="d-flex justify-content-between">
                <div class="sort-block">
                    <p class="sort-text" style="margin-bottom: 0;">Sort by: <span>{{ orderLabel[orderBy].replace('Standart', 'Standard') }}</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="down-arrow" fill="#2ea762"><path d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"></path></svg></p>
                    <select class="sort-select" v-model="orderBy">
                        <option value="standart">{{ orderLabel.standart.replace('Standart', 'Standard') }}</option>
                        <option value="duration">{{ orderLabel.duration }}</option>
                        <option value="departure_time">{{ orderLabel.departure_time }}</option>
                        <option value="arrival_time">{{ orderLabel.arrival_time }}</option>
                    </select>
                </div>
                <div class="filterIcon">
                    <div class="d-flex">
                        <div @click="clearFilters" class="btn btn-light d-flex me-2" v-if="showClearFilters"><span style="margin-right: 5px;">Clear</span><i class="bi bi-x" style="font-size: 18px;"></i></div>
                        <div @click="toggleFilter" class="btn btn-light d-flex"><span style="margin-right: 5px;">Filter</span><i class="bi bi-filter" style="font-size: 18px;"></i></div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="orderBy === 'standart'">

            <template v-if="groupedRoutes.direct.length > 0">

                <div class="headline direct">Direct flights 😃</div>
                <route-item class="" v-for="(route, idx1) in groupedRoutes.direct" :current-date="currentDate" :max-duration="maxDuration" :force-close="forceClose" :route="route" @open="closeAllChilds" :open-all="idx1 === 0 && openFirst"></route-item>

            </template>

            <template v-if="groupedRoutes.connection.length > 0">

                <div class="headline connect">Flights with stop</div>
                <route-item class="" v-for="(route, idx2) in groupedRoutes.connection" :current-date="currentDate" :max-duration="maxDuration" :force-close="forceClose" :route="route" @open="closeAllChilds" :open-all="idx2 === 0 && openFirst"></route-item>

            </template>

            <template v-if="groupedRoutes.other.length > 0">

                <div class="headline other">Multiple airlines</div>
                <route-item class="" v-for="(route, idx3) in groupedRoutes.other" :current-date="currentDate" :max-duration="maxDuration" :force-close="forceClose" :route="route" @open="closeAllChilds" :open-all="idx3 === 0 && openFirst"></route-item>

            </template>

        </template>

        <template v-else>

            <route-item v-for="route in sortedRoutes" :current-date="currentDate" :max-duration="maxDuration" :force-close="forceClose" :route="route" @open="closeAllChilds"></route-item>

        </template>

    </div>
</template>

<script>
import Slider from '@vueform/slider'
import RouteItem from "./RouteItem.vue";
export default {
    name: "RouteList",
    components: {
        Slider,
        RouteItem
    },
    props: {
        filtersRaw: {
            required: true
        },
        routesRaw: {
            required: true
        },
        airportToName: {
            required: true
        },
        currentDate: {
            required: true
        },
    },
    data() {
        return {
            forceClose: null,
            changeSearch: false,
            orderBy: 'standart',
            routesAmount: null,
            direct:     'direct',
            other:      'other',
            connection: 'connection',
            openFirst: false,
            routes: [],
            filters: [],
            backOrderBy: 'duration',
            orderLabel: {
                standart: "Standart",
                duration: "Shortest flight time",
                departure_time: "Departure time",
                arrival_time: "Arrival time",
                layover_time: "Layover time"
            },
            filterLabel: {
                'iata_via': 'Layover airport',
                'airline': 'Airlines',
                'aircrafts': 'Aircraft',
                'class': 'Class',
                duration: "Flight time",
                departure_time: "Departure time",
                arrival_time: "Arrival time",
                layover_time: "Layover time",
                alliance: "Alliance"
            },
            filterState: {
                iata_via: [],
                airline: [],
                aircrafts: [],
                class: [],
                alliance: [],
                duration: [0,1440],
                layover_time: [0,1440],
                departure_time: [0,1440],
                arrival_time: [0,1440]
            },
            filtersCount: {
                iata_via: {},
                airline: {},
                alliance: {},
                aircrafts: {},
                class: {},
            },
            classMap: {
                'economy' : ['Y','H','K','M','L','G','V','S','N','Q','O','E'],
                'basic_economy' : ['B'],
                'premium_economy': ['W','P'],
                'business': ['C','J','R','D','I'],
                'first': ['A','F']
            },
            forceFilter: 0,
            filtersOpen: false,
            firstLoad: true,
            lowCostAirlines: []
        }
    },
    watch: {
        filterState: {
            handler(newValue) {
                if (!this.firstLoad) {
                    this.forceFilter++;
                    this.$nextTick(function() {
                        this.updateFilterUrl();
                    })
                }
            },
            deep: true
        },
        routesAmount() {
            let params = new URLSearchParams(window.location.search);

            if(!params.toString()) {
                this.openFirst = true;
            }
        }
    },
    computed: {
        showClearFilters() {
            const emptyState = {
                iata_via: [],
                airline: [],
                aircrafts: [],
                class: [],
                alliance: [],
                duration: this.filters.duration,
                layover_time: this.filters.layover_time,
                departure_time: [0,1440],
                arrival_time: [0,1440]
            };
            return JSON.stringify(this.filterState) !== JSON.stringify(emptyState)
        },
        maxDuration(){
            let maxDuration = 0;
            this.routes.forEach((item) => {
                if (item.duration > maxDuration) {
                    maxDuration = item.duration;
                }
            });

            return maxDuration;
        },
        minDuration(){
            let min = null;
            this.routes.forEach((item) => {
                if (min === null) {
                    min = item.duration;
                }
                if (item.duration < min) {
                    min = item.duration;
                }
            });

            return min;
        },
        groupedRoutes() {
            const grouped = {
                'direct': [],
                'connection': [],
                'other': []
            }

            this.sortedRoutes.forEach((item) => {
                if (item.is_direct) {
                    grouped.direct.push(item);
                    return;
                }
                if (item.l1_airline.IATA === item.l2_airline.IATA) {
                    grouped.connection.push(item);
                    return;
                }
                grouped.other.push(item);
            });
            this.routesAmount = grouped.direct.length + grouped.connection.length + grouped.other.length;
            return grouped;
        },
        sortedRoutes() {
            const key = this.orderBy === 'standart' ? 'duration' : this.orderBy;
            return this.filteredData.sort((a,b) => {
                if (typeof (a[key]) === 'string' && a[key].includes(':')) {
                    let time1 = a[key].split(':');
                    let time2 = b[key].split(':');
                    let minutes1 = (time1[0] * 60) + time1[1];
                    let minutes2 = (time2[0] * 60) + time2[1];
                    return minutes1-minutes2;
                }
                return a[key]-b[key]
            });
        },
        sortedBack() {
            const key = this.backOrderBy;
            return this.routes_back.sort((a,b) => {
                if (typeof (a[key]) === 'string' && a[key].includes(':')) {
                    let time1 = a[key].split(':');
                    let time2 = b[key].split(':');
                    let minutes1 = (time1[0] * 60) + time1[1];
                    let minutes2 = (time2[0] * 60) + time2[1];
                    return minutes1-minutes2;
                }
                return a[key]-b[key]
            });
        },
        directFlightsCount() {
            return this.routes.filter((item) => {
                return item.is_direct
            }).length;
        },
        filteredData() {
            this.forceFilter;
            return this.filterRoutes();
        }
    },
    mounted() {
        this.routes = JSON.parse(this.routesRaw);
        this.routes.forEach((item) => {
            if (item.is_direct) {
                if (item.airline.is_lowcost) {
                    if (!this.lowCostAirlines.includes(item.airline.IATA)) {
                        this.lowCostAirlines.push(item.airline.IATA);
                    }
                }
            } else {
                if (item.l1_airline.is_lowcost) {
                    if (!this.lowCostAirlines.includes(item.l1_airline.IATA)) {
                        this.lowCostAirlines.push(item.l1_airline.IATA);
                    }
                }
                if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                    if (item.l2_airline.is_lowcost) {
                        if (!this.lowCostAirlines.includes(item.l2_airline.IATA)) {
                            this.lowCostAirlines.push(item.l2_airline.IATA);
                        }
                    }
                }
            }
        });
        this.filters = JSON.parse(this.filtersRaw);
        this.filterState.layover_time = this.filters.layover_time;
        this.filterState.duration = this.filters.duration;
        const searchURL = new URL(window.location);
        for (const [key, value] of searchURL.searchParams.entries()) {
            if (Object.keys(this.filterState).includes(key)){
                this.filterState[key] = value.split(',');
            }
        }
        this.countFilters();
        this.firstLoad = false;
    },
    methods: {
        closeAllChilds(event) {
            this.forceClose = event.id;
        },
        updateFilterUrl() {

            const searchURL = new URL(window.location);
            const values = [];
            const newParams = new URLSearchParams();
            for (const [key, value] of searchURL.searchParams.entries()) {
                if (!Object.keys(this.filterState).includes(key)){
                    values.push({key, value});
                }
                searchURL.searchParams.delete(key);
            }

            Object.keys(this.filterState).sort().forEach((item) => {
                if (this.filterState[item].length > 0 && ( this.filterState[item][0] !== this.filters[item][0] || this.filterState[item][1] !== this.filters[item][1])) {
                    values.push({key: item, value: this.filterState[item].join(',')});
                }
            });


            values.forEach((item) => {
                newParams.append(item.key, item.value);
            });


            searchURL.search = newParams.toString();

            window.history.pushState({}, '', searchURL);

        },
        clearFilters() {
            this.filterState = {
                iata_via: [],
                airline: [],
                aircrafts: [],
                class: [],
                alliance: [],
                duration: this.filters.duration,
                layover_time: this.filters.layover_time,
                departure_time: [0,1440],
                arrival_time: [0,1440]
            };
            this.countFilters();
        },
        toggleFilter() {
            this.countFilters();
            this.filtersOpen = !this.filtersOpen;
        },
        closeFilters() {
            this.filtersOpen = false;
        },
        formatLabel(value) {
            const hours = Math.floor(value / 60);
            const remainingMinutes = Math.floor(value % 60);
            return `${hours}:${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
        },
        convertTime(time) {
            const splitTime = time.split(":");
            return splitTime[0]+':'+splitTime[1];
        },
        convertMinutesToTime(minutes, separator = '') {
            const hours = Math.floor(minutes / 60);
            let remainingMinutes = minutes % 60;
            if (remainingMinutes < 10) {
                remainingMinutes = '0'+remainingMinutes;
            }
            return hours + "h" + separator + remainingMinutes + "m";
        },
        calculateWidth(current) {
            return (current/this.maxDuration) * 100;
        },
        isLowcost(route) {
            if (route.airline) {
                return parseInt(route.airline.is_lowcost) === 1
            }
            return route.l1_airline.is_lowcost === 1 || route.l2_airline.is_lowcost === 1;
        },
        isOverNight(route) {
            let start = route.departure_time.split(':');
            let end = route.arrival_time.split(':');
            let flag = (start[0] >= 23 && route.duration >= 300) || (end[0] <= 6 && route.duration >= 300);
            if (!flag) {
                if (!route.is_direct) {
                    let hoursstart = Math.floor(route.l1_flight_time / 60);
                    let hoursEnd = Math.floor(route.l2_flight_time / 60);
                    if ((parseInt(start[0]) + hoursstart - 23) >= 5) {
                        flag = true;
                    }
                    if (parseInt(end[0]) - hoursEnd <= 1 ) {
                        flag = true;
                    }
                }
            }
            return flag;

        },
        modifyFilters(event, key) {
            this.forceClose = null;
            this.$nextTick(() => {
                if (key === 'iata_via') {
                    if (event.target.value === 'NONSTOP') {
                        // console.log(this.filterState)
                        //this.filterState.iata_via = ['NONSTOP'];
                        //this.filterState.layover_time = this.filters.layover_time;
                    } else {
                        if (this.filterState.iata_via.includes('NONSTOP')) {
                            const index = this.filterState.iata_via.indexOf('NONSTOP');
                            this.filterState.iata_via.splice(index, 1);
                        }
                    }
                }
                if (key === 'layover_time') {
                    if (this.filterState.iata_via.includes('NONSTOP')) {
                        const index = this.filterState.iata_via.indexOf('NONSTOP');
                        this.filterState.iata_via.splice(index, 1);
                    }
                }
                if (key === 'airline') {
                    if (!['SAMEBOTH','NOCODESHARE'].includes(event.target.value)){
                        this.filterState.alliance = [];
                    }
                    if (event.target.value === 'ONLYLOW') {
                        const empty = this.filterState.airline.filter((item) => {
                            return ['SAMEBOTH','NOCODESHARE'].includes(item);
                        });
                        this.filterState.airline = [...empty, ...this.lowCostAirlines, 'ONLYLOW'];
                    }
                    if (event.target.value === 'NOLOW') {
                        const empty = this.filterState.airline.filter((item) => {
                            return ['SAMEBOTH','NOCODESHARE'].includes(item) || ![...this.lowCostAirlines, 'ONLYLOW'].includes(item);
                        });
                        // console.log(empty);
                        this.filterState.airline = [...empty];
                    }
                }
                if (key === 'alliance'){
                    const empty = [];
                    if (this.filterState.airline.includes('SAMEBOTH')) {
                        empty.push('SAMEBOTH')
                    }
                    if (this.filterState.airline.includes('NOCODESHARE')) {
                        empty.push('NOCODESHARE')
                    }
                    this.filterState.airline = empty;
                }
                this.countFilters();
            });
        },
        countFilters() {
            const filterCount = {
                iata_via: {},
                airline: {},
                alliance: {},
                aircrafts: {},
                class: {},
            };
            this.filteredData.forEach((item) => {
                Object.keys(this.filters).forEach((key) => {
                    switch (key) {
                        case 'iata_via':
                            if (item.iata_via) {
                                if (item.airport_via.is_schengen === 1) {
                                    if (filterCount.iata_via['SCHENGEN']) {
                                        filterCount.iata_via['SCHENGEN']++;
                                    } else {
                                        filterCount.iata_via['SCHENGEN'] = 1;
                                    }
                                }
                                if (filterCount.iata_via[item.iata_via]) {
                                    filterCount.iata_via[item.iata_via]++;
                                } else {
                                    filterCount.iata_via[item.iata_via] = 1;
                                }
                            } else {
                                if (filterCount.iata_via['NONSTOP']) {
                                    filterCount.iata_via['NONSTOP']++;
                                } else {
                                    filterCount.iata_via['NONSTOP'] = 1;
                                }
                            }
                            break;
                        case 'airline':
                            if (item.is_direct) {
                                if (filterCount.airline['SAMEBOTH']) {
                                    filterCount.airline['SAMEBOTH']++;
                                } else {
                                    filterCount.airline['SAMEBOTH'] = 1;
                                }
                                if (item.airline.is_lowcost) {
                                    if (filterCount.airline['ONLYLOW']) {
                                        filterCount.airline['ONLYLOW']++;
                                    } else {
                                        filterCount.airline['ONLYLOW'] = 1;
                                    }
                                } else {
                                    if (filterCount.airline['NOLOW']) {
                                        filterCount.airline['NOLOW']++;
                                    } else {
                                        filterCount.airline['NOLOW'] = 1;
                                    }
                                }
                                if (filterCount.airline[item.airline.IATA]) {
                                    filterCount.airline[item.airline.IATA]++;
                                } else {
                                    filterCount.airline[item.airline.IATA] = 1;
                                }
                            } else {
                                if (item.l1_airline.IATA === item.l2_airline.IATA) {
                                    if (filterCount.airline['SAMEBOTH']) {
                                        filterCount.airline['SAMEBOTH']++;
                                    } else {
                                        filterCount.airline['SAMEBOTH'] = 1;
                                    }
                                }
                                if (!item.is_codeshare) {
                                    if (filterCount.airline['NOCODESHARE']) {
                                        filterCount.airline['NOCODESHARE']++;
                                    } else {
                                        filterCount.airline['NOCODESHARE'] = 1;
                                    }
                                }
                                if (item.l1_airline.is_lowcost || item.l2_airline.is_lowcost) {
                                    if (filterCount.airline['ONLYLOW']) {
                                        filterCount.airline['ONLYLOW']++;
                                    } else {
                                        filterCount.airline['ONLYLOW'] = 1;
                                    }
                                } else {
                                    if (filterCount.airline['NOLOW']) {
                                        filterCount.airline['NOLOW']++;
                                    } else {
                                        filterCount.airline['NOLOW'] = 1;
                                    }
                                }
                                if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                                    if (filterCount.airline[item.l1_airline.IATA]) {
                                        filterCount.airline[item.l1_airline.IATA]++;
                                    } else {
                                        filterCount.airline[item.l1_airline.IATA] = 1;
                                    }
                                    if (filterCount.airline[item.l2_airline.IATA]) {
                                        filterCount.airline[item.l2_airline.IATA]++;
                                    } else {
                                        filterCount.airline[item.l2_airline.IATA] = 1;
                                    }
                                } else {
                                    if (filterCount.airline[item.l1_airline.IATA]) {
                                        filterCount.airline[item.l1_airline.IATA]++;
                                    } else {
                                        filterCount.airline[item.l1_airline.IATA] = 1;
                                    }
                                }

                            }
                            break;
                        case 'aircrafts':
                            if (item.is_direct) {
                                if (filterCount.aircrafts[item.aircraft_code]) {
                                    filterCount.aircrafts[item.aircraft_code]++;
                                } else {
                                    filterCount.aircrafts[item.aircraft_code] = 1;
                                }
                            } else {
                                if (filterCount.aircrafts[item.l1_aircraft_code]) {
                                    filterCount.aircrafts[item.l1_aircraft_code]++;
                                } else {
                                    filterCount.aircrafts[item.l1_aircraft_code] = 1;
                                }
                                if (filterCount.aircrafts[item.l2_aircraft_code]) {
                                    filterCount.aircrafts[item.l2_aircraft_code]++;
                                } else {
                                    filterCount.aircrafts[item.l2_aircraft_code] = 1;
                                }
                            }
                            break;
                        case 'class':
                            if (item.is_direct) {
                                const classes = item.classes.split('');
                                classes.forEach((cl) => {
                                    Object.keys(this.classMap).forEach((class_slug) => {
                                        this.classMap[class_slug].forEach((tocheck) => {
                                            if (cl === tocheck) {
                                                if (filterCount.class[class_slug]) {
                                                    filterCount.class[class_slug]++;
                                                } else {
                                                    filterCount.class[class_slug] = 1;
                                                }
                                            }
                                        })
                                    });
                                });
                            } else {
                                let classes = item.l1_classes.split('');
                                classes.forEach((cl) => {
                                    Object.keys(this.classMap).forEach((class_slug) => {
                                        this.classMap[class_slug].forEach((tocheck) => {
                                            if (cl === tocheck) {
                                                if (filterCount.class[class_slug]) {
                                                    filterCount.class[class_slug]++;
                                                } else {
                                                    filterCount.class[class_slug] = 1;
                                                }
                                            }
                                        })
                                    });
                                });
                                classes = item.l2_classes.split('');
                                classes.forEach((cl) => {
                                    Object.keys(this.classMap).forEach((class_slug) => {
                                        this.classMap[class_slug].forEach((tocheck) => {
                                            if (cl === tocheck) {
                                                if (filterCount.class[class_slug]) {
                                                    filterCount.class[class_slug]++;
                                                } else {
                                                    filterCount.class[class_slug] = 1;
                                                }
                                            }
                                        })
                                    });
                                });
                            }
                            break;
                        case 'alliance':
                            const values = [
                                'is_staralliance',
                                'is_skyteam',
                                'is_oneworld'
                            ];
                            if (item.is_direct) {
                                values.forEach((attribute) => {
                                    if (item.airline[attribute]) {
                                        if (filterCount.alliance[attribute]) {
                                            filterCount.alliance[attribute]++;
                                        } else {
                                            filterCount.alliance[attribute] = 1;
                                        }
                                    }
                                });
                            } else {
                                values.forEach((attribute) => {
                                    if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                                        if (item.l1_airline[attribute] && item.l2_airline[attribute]) {
                                            if (filterCount.alliance[attribute]) {
                                                filterCount.alliance[attribute]++;
                                            } else {
                                                filterCount.alliance[attribute] = 1;
                                            }
                                        }
                                    } else {
                                        if (item.l1_airline[attribute]) {
                                            if (filterCount.alliance[attribute]) {
                                                filterCount.alliance[attribute]++;
                                            } else {
                                                filterCount.alliance[attribute] = 1;
                                            }
                                        }
                                    }
                                });
                            }
                            break;
                    }
                });
            });

            if (this.filterState.iata_via.length > 0) {
                filterCount.iata_via = {};
                this.filterRoutes('iata_via').forEach((item) => {
                    if (item.iata_via) {
                        if (item.airport_via.is_schengen === 1) {
                            if (filterCount.iata_via['SCHENGEN']) {
                                filterCount.iata_via['SCHENGEN']++;
                            } else {
                                filterCount.iata_via['SCHENGEN'] = 1;
                            }
                        }
                        if (filterCount.iata_via[item.iata_via]) {
                            filterCount.iata_via[item.iata_via]++;
                        } else {
                            filterCount.iata_via[item.iata_via] = 1;
                        }
                    } else {
                        if (filterCount.iata_via['NONSTOP']) {
                            filterCount.iata_via['NONSTOP']++;
                        } else {
                            filterCount.iata_via['NONSTOP'] = 1;
                        }
                    }
                });
            }

            if (this.filterState.airline.length > 0) {
                filterCount.airline = {};
                this.filterRoutes('airline').forEach((item) => {
                    if (item.is_direct) {
                        if (item.airline.is_lowcost) {
                            if (filterCount.airline['ONLYLOW']) {
                                filterCount.airline['ONLYLOW']++;
                            } else {
                                filterCount.airline['ONLYLOW'] = 1;
                            }
                        } else {
                            if (filterCount.airline['NOLOW']) {
                                filterCount.airline['NOLOW']++;
                            } else {
                                filterCount.airline['NOLOW'] = 1;
                            }
                        }
                        if (filterCount.airline['SAMEBOTH']) {
                            filterCount.airline['SAMEBOTH']++;
                        } else {
                            filterCount.airline['SAMEBOTH'] = 1;
                        }
                        if (filterCount.airline[item.airline.IATA]) {
                            filterCount.airline[item.airline.IATA]++;
                        } else {
                            filterCount.airline[item.airline.IATA] = 1;
                        }
                    } else {
                        if (item.l1_airline.IATA === item.l2_airline.IATA) {
                            if (filterCount.airline['SAMEBOTH']) {
                                filterCount.airline['SAMEBOTH']++;
                            } else {
                                filterCount.airline['SAMEBOTH'] = 1;
                            }
                        }
                        if (!item.is_codeshare) {
                            if (filterCount.airline['NOCODESHARE']) {
                                filterCount.airline['NOCODESHARE']++;
                            } else {
                                filterCount.airline['NOCODESHARE'] = 1;
                            }
                        }
                        if (item.l1_airline.is_lowcost || item.l2_airline.is_lowcost) {
                            if (filterCount.airline['ONLYLOW']) {
                                filterCount.airline['ONLYLOW']++;
                            } else {
                                filterCount.airline['ONLYLOW'] = 1;
                            }
                        } else {
                            if (filterCount.airline['NOLOW']) {
                                filterCount.airline['NOLOW']++;
                            } else {
                                filterCount.airline['NOLOW'] = 1;
                            }
                        }
                        if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                            if (filterCount.airline[item.l1_airline.IATA]) {
                                filterCount.airline[item.l1_airline.IATA]++;
                            } else {
                                filterCount.airline[item.l1_airline.IATA] = 1;
                            }
                            if (filterCount.airline[item.l2_airline.IATA]) {
                                filterCount.airline[item.l2_airline.IATA]++;
                            } else {
                                filterCount.airline[item.l2_airline.IATA] = 1;
                            }
                        } else {
                            if (filterCount.airline[item.l1_airline.IATA]) {
                                filterCount.airline[item.l1_airline.IATA]++;
                            } else {
                                filterCount.airline[item.l1_airline.IATA] = 1;
                            }
                        }

                    }
                });
            }

            if (this.filterState.alliance.length > 0) {
                filterCount.alliance = {};
                this.filterRoutes('alliance').forEach((item) => {
                    const values = [
                        'is_staralliance',
                        'is_skyteam',
                        'is_oneworld'
                    ];
                    if (item.is_direct) {
                        values.forEach((attribute) => {
                            if (item.airline[attribute]) {
                                if (filterCount.alliance[attribute]) {
                                    filterCount.alliance[attribute]++;
                                } else {
                                    filterCount.alliance[attribute] = 1;
                                }
                            }
                        });
                    } else {
                        values.forEach((attribute) => {
                            if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                                if (item.l1_airline[attribute] && item.l2_airline[attribute]) {
                                    if (filterCount.alliance[attribute]) {
                                        filterCount.alliance[attribute]++;
                                    } else {
                                        filterCount.alliance[attribute] = 1;
                                    }
                                }
                                // if (item.l2_airline[attribute]) {
                                //     if (filterCount.alliance[attribute]) {
                                //         filterCount.alliance[attribute]++;
                                //     } else {
                                //         filterCount.alliance[attribute] = 1;
                                //     }
                                // }
                            } else {
                                if (item.l1_airline[attribute]) {
                                    if (filterCount.alliance[attribute]) {
                                        filterCount.alliance[attribute]++;
                                    } else {
                                        filterCount.alliance[attribute] = 1;
                                    }
                                }
                            }
                        });
                    }
                });
            }

            if (this.filterState.aircrafts.length > 0) {
                filterCount.aircrafts = {};
                this.filterRoutes('aircrafts').forEach((item) => {
                    if (item.is_direct) {
                        if (filterCount.aircrafts[item.aircraft_code]) {
                            filterCount.aircrafts[item.aircraft_code]++;
                        } else {
                            filterCount.aircrafts[item.aircraft_code] = 1;
                        }
                    } else {
                        if (filterCount.aircrafts[item.l1_aircraft_code]) {
                            filterCount.aircrafts[item.l1_aircraft_code]++;
                        } else {
                            filterCount.aircrafts[item.l1_aircraft_code] = 1;
                        }
                        if (filterCount.aircrafts[item.l2_aircraft_code]) {
                            filterCount.aircrafts[item.l2_aircraft_code]++;
                        } else {
                            filterCount.aircrafts[item.l2_aircraft_code] = 1;
                        }
                    }
                });
            }

            if (this.filterState.class.length > 0) {
                filterCount.class = {};
                this.filterRoutes('class').forEach((item) => {
                    if (item.is_direct) {
                        const classes = item.classes.split('');
                        classes.forEach((cl) => {
                            Object.keys(this.classMap).forEach((class_slug) => {
                                this.classMap[class_slug].forEach((tocheck) => {
                                    if (cl === tocheck) {
                                        if (filterCount.class[class_slug]) {
                                            filterCount.class[class_slug]++;
                                        } else {
                                            filterCount.class[class_slug] = 1;
                                        }
                                    }
                                })
                            });
                        });
                    } else {
                        let classes = item.l1_classes.split('');
                        classes.forEach((cl) => {
                            Object.keys(this.classMap).forEach((class_slug) => {
                                this.classMap[class_slug].forEach((tocheck) => {
                                    if (cl === tocheck) {
                                        if (filterCount.class[class_slug]) {
                                            filterCount.class[class_slug]++;
                                        } else {
                                            filterCount.class[class_slug] = 1;
                                        }
                                    }
                                })
                            });
                        });
                        classes = item.l2_classes.split('');
                        classes.forEach((cl) => {
                            Object.keys(this.classMap).forEach((class_slug) => {
                                this.classMap[class_slug].forEach((tocheck) => {
                                    if (cl === tocheck) {
                                        if (filterCount.class[class_slug]) {
                                            filterCount.class[class_slug]++;
                                        } else {
                                            filterCount.class[class_slug] = 1;
                                        }
                                    }
                                })
                            });
                        });
                    }
                });
            }


            this.filtersCount = filterCount;
        },
        filterRoutes(skip = null) {
            return this.routes.filter((item) => {
                let filtered = true;
                Object.keys(this.filterState).forEach((key) => {
                    if (this.filterState[key].length > 0) {
                        if (skip !== null && key === skip) {
                            return;
                        }
                        switch (key) {
                            case 'airline':
                                if (item.is_direct) {
                                    if (this.filterState[key].includes('SAMEBOTH')) {
                                        if (this.filterState[key].length > 1) {
                                            if (
                                                !this.filterState[key].includes('NOLOW') &&
                                                !this.filterState[key].includes('ONLYLOW') &&
                                                !this.filterState[key].includes(item.airline.IATA)
                                            ) {
                                                filtered = false;
                                            } else if (this.filterState[key].includes('NOLOW')) {
                                                if (item.airline.is_lowcost) {
                                                    filtered = false;
                                                }
                                            } else if (this.filterState[key].includes('ONLYLOW')) {
                                                if (!item.airline.is_lowcost) {
                                                    filtered = false;
                                                }
                                            }
                                        }
                                    } else if (this.filterState[key].includes('NOLOW')) {
                                        if (item.airline.is_lowcost) {
                                            filtered = false;
                                        }
                                    } else if (this.filterState[key].includes('ONLYLOW')) {
                                        if (!item.airline.is_lowcost) {
                                            filtered = false;
                                        }
                                    } else if (!this.filterState[key].includes(item.airline.IATA)){
                                        filtered = false;
                                    }
                                } else {
                                    if (this.filterState[key].includes('SAMEBOTH')) {
                                        if (item.l1_airline.IATA !== item.l2_airline.IATA) {
                                            filtered = false;
                                        } else if (this.filterState[key].length > 1) {
                                            if (this.filterState[key].includes('NOCODESHARE')) {
                                                if (item.is_codeshare) {
                                                    filtered = false;
                                                }
                                            } else if (this.filterState[key].includes('NOLOW')) {
                                                if (item.l1_airline.is_lowcost || item.l2_airline.is_lowcost) {
                                                    filtered = false;
                                                }
                                            } else if (this.filterState[key].includes('ONLYLOW')) {
                                                if (!item.l1_airline.is_lowcost || !item.l2_airline.is_lowcost) {
                                                    filtered = false;
                                                }
                                            } else if (!this.filterState[key].includes(item.l1_airline.IATA) && !this.filterState[key].includes(item.l2_airline.IATA)) {
                                                filtered = false;
                                            }
                                        }
                                    } else if (this.filterState[key].includes('NOCODESHARE')) {
                                        if (item.is_codeshare) {
                                            filtered = false;
                                        }
                                    } else if (this.filterState[key].includes('NOLOW')) {
                                        if (item.l1_airline.is_lowcost || item.l2_airline.is_lowcost) {
                                            filtered = false;
                                        }
                                    } else if (this.filterState[key].includes('ONLYLOW')) {
                                        if (!item.l1_airline.is_lowcost || !item.l2_airline.is_lowcost) {
                                            filtered = false;
                                        }
                                    } else if (!this.filterState[key].includes(item.l1_airline.IATA) && !this.filterState[key].includes(item.l2_airline.IATA)){
                                        filtered = false;
                                    }
                                }
                                break;
                            case 'aircrafts':
                                if (item.is_direct) {
                                    if (!this.filterState[key].includes(item.aircraft_code)){
                                        filtered = false;
                                    }
                                } else {
                                    if (!this.filterState[key].includes(item.l1_aircraft_code) && !this.filterState[key].includes(item.l2_aircraft_code)){
                                        filtered = false;
                                    }
                                }
                                break;
                            case 'class':
                                let classFound = false;
                                if (item.is_direct) {
                                    this.filterState[key].forEach((selected) => {
                                        const classes = this.classMap[selected];
                                        classes.forEach((class_iata) => {
                                            if (item.classes.includes(class_iata)) {
                                                classFound = true;
                                            }
                                        })
                                    });
                                } else {
                                    this.filterState[key].forEach((selected) => {
                                        const classes = this.classMap[selected];
                                        classes.forEach((class_iata) => {
                                            if (item.l1_classes.includes(class_iata) || item.l2_classes.includes(class_iata)) {
                                                classFound = true;
                                            }
                                        });

                                    });
                                }
                                if (!classFound) filtered = false;
                                break;
                            case 'duration':
                                const durationArray = this.filterState[key];
                                if (item.duration < durationArray[0] || item.duration > durationArray[1]) {
                                    filtered = false;
                                }
                                break;
                            case 'layover_time':
                                if (item.is_direct) {
                                    if (this.filterState[key][0] !== this.filters.layover_time[0] ||  this.filterState[key][1] !== this.filters.layover_time[1]) {
                                        filtered = false;
                                    }
                                } else {
                                    const layoverArray = this.filterState[key];
                                    if (item.layover_time_total < layoverArray[0] || item.layover_time_total > layoverArray[1]) {
                                        filtered = false;
                                    }
                                }
                                break;
                            case 'departure_time':
                                const departureArray = this.filterState[key];
                                let deptime = item.departure_time.split(':');
                                const deeptimeinminutes = parseInt(deptime[0]) * 60 + parseInt(deptime[1]);
                                if (deeptimeinminutes < departureArray[0] || deeptimeinminutes > departureArray[1]) {
                                    filtered = false;
                                }
                                break;
                            case 'arrival_time':
                                const arrivalArray = this.filterState[key];
                                let arrtime = item.arrival_time.split(':');
                                const arrtimeinminutes = parseInt(arrtime[0]) * 60 + parseInt(arrtime[1]);
                                if (arrtimeinminutes < arrivalArray[0] || arrtimeinminutes > arrivalArray[1]) {
                                    filtered = false;
                                }
                                break;
                            case 'iata_via':
                                if (this.filterState[key].includes('NONSTOP')) {
                                    if (!item.is_direct) {
                                        filtered = false;
                                    }
                                } else if (this.filterState[key].includes('SCHENGEN')) {
                                    if (item.is_direct || ( item.airport_via && item.airport_via.is_schengen === 0 )) {
                                        filtered = false;
                                    }
                                } else if (!this.filterState[key].includes(item[key])){
                                    filtered = false;
                                }
                                break;
                            case 'alliance':
                                let flag = false;
                                this.filterState[key].forEach((attribute) => {
                                    if (item.is_direct) {
                                        if (item.airline[attribute]) {
                                            flag = true;
                                        }
                                    } else {
                                        if (item.l1_airline[attribute] && item.l2_airline[attribute]) {
                                            flag = true;
                                        }
                                    }

                                })
                                if (filtered) filtered = flag;
                                break;
                            default:
                                if (!this.filterState[key].includes(item[key])){
                                    filtered = false;
                                }
                                break;
                        }
                    }
                });
                return filtered;
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@vueform/slider/themes/default.css';

</style>
